// extracted by mini-css-extract-plugin
module.exports = {"layoutBox":"RotTool_layoutBox__3uxkl","center":"RotTool_center__1D4wP","title":"RotTool_title__sJkIt","flexList":"RotTool_flexList__2TQAX"};